import { NumberInput } from '@library/components/inputs';
import type { ProbabilityType } from '@library/types/trading';
import { classNames } from '@library/utils';

export interface TradeSettingsProbabilityInputProps {
  className?: string;
  disabled?: boolean;
  probabilityType: ProbabilityType;
  onValueChange: ({
    key,
    value
  }: {
    key: ProbabilityType;
    value: number | undefined;
  }) => void;
  value: number | undefined;
}

export const TradeSettingsProbabilityInput = ({
  className = '',
  disabled = false,
  probabilityType,
  onValueChange,
  value
}: TradeSettingsProbabilityInputProps) => {
  return (
    <td className="py-4 text-center">
      <NumberInput
        className={classNames(
          'focus:border-msJackson bg-soFresh-120 border-soFresh-140 text-soClean-100 mx-auto h-8 w-14 justify-center rounded-md p-0 text-center text-sm font-medium leading-5 tracking-tight',
          className
        )}
        disabled={disabled}
        id={probabilityType}
        onValueChange={(newValue) =>
          onValueChange({
            key: probabilityType,
            value: newValue.length > 0 ? Number(newValue) : undefined
          })
        }
        value={value ?? ''}
      />
    </td>
  );
};
